import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ListComponent } from 'src/app/common/component/list.component';
import { SectionService } from '../section.service';

@Component({
	selector: 'app-section-list',
	templateUrl: './section-list.component.html',
	styleUrls: ['./section-list.component.scss'],
})
export class SectionListComponent extends ListComponent {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	protected itemsBeforeDataLoad = 1;
	protected apiType = 'bag';
	protected apiUrl = 'www/section';
	protected filterValue = '';
	protected listChange = false;
	protected service = new SectionService();

	displayedColumns: string[] = ['name', 'kind', 'isActive', 'edit'];
	matData = new MatTableDataSource<any>();

	dropTable(event: CdkDragDrop<any>): void {
		moveItemInArray(this.matData.data, event.previousIndex, event.currentIndex);
		this.table.renderRows();
		this.listChange = true;
	}

	save(data): void {
		data.data.forEach((element, id) => {
			if (element.order == id) {
				return;
			}
			element.order = id;
			this.bag.put('/www/section/' + element.id + '/', element, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
			});
		});
	}

	refreshFilter(): void {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	protected loadBefore(): void {
		this.loadData();
	}
	protected convertData(result): void {
		this.matData.data = result.results;
	}

	protected getKind(kind): string {
		return this.service.kindSet.find((findObj) => findObj.value === kind).name;
	}
}
